import Vue from 'vue';
import VueI18n from 'vue-i18n';
import getBrowserLocale from '@/util/i18n/get-browser-locale';
import supportedLocales from '@/config/supported-locales';
import { supportedLocalesInclude } from './util/i18n/supported-locales';

Vue.use(VueI18n);

function getLocaleMessages() {
  const messages = {};

  Object.keys(supportedLocales).forEach((locale) => {
    import(`@/locales/${locale}`).then((loadedMessage) => { messages[locale] = loadedMessage.default; });
  });

  return messages;
}

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true });

  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale;
  }

  return process.env.VUE_APP_I18N_LOCALE || 'en';
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: getLocaleMessages(),
});
